/**
 * youtube-modal
 */
import modaal from 'modaal/dist/js/modaal';
import 'modaal/dist/css/modaal.scss';
import $ from 'jquery';

// Module dependencies
import 'protons';

// Module styles
import './_youtube-modal.scss';

// Module template
import './_youtube-modal.twig';

export const name = 'youtube-modal';

export const defaults = {
  dummyClass: 'js-youtube-modal-exists',
};

/**
 * Components may need to run clean-up tasks if they are removed from DOM.
 *
 * @param {jQuery} $context - A piece of DOM
 * @param {Object} settings - Pertinent settings
 */
// eslint-disable-next-line no-unused-vars
export function disable($context, settings) {}

/**
 * Each component has a chance to run when its enable function is called. It is
 * given a piece of DOM ($context) and a settings object. We destructure our
 * component key off the settings object and provide an empty object fallback.
 * Incoming settings override default settings via Object.assign().
 *
 * @param {jQuery} $context - A piece of DOM
 * @param {Object} settings - Settings object
 */
export function enable($context, { youtubeModal = {} }) {
  // Find our component within the DOM
  const $youtubeModal = $('.youtube-modal', $context);
  // Bail if component does not exist
  if (!$youtubeModal.length) {
    return;
  }

  // Merge defaults with incoming settings
  const settings = {
    ...defaults,
    ...youtubeModal,
  };
  // An example of what could be done with this component
  $youtubeModal.addClass(settings.dummyClass);
}

$(document).ready(() => {
  if (modaal && $('.youtube-modal').length) {
    $('.youtube-modal').modaal({
      type: 'video',
    });
  }
});

export default enable;
